<template>
  <el-container class="creator-center">
    <el-header class="header">
      <CreatorHeader />
    </el-header>

    <el-container>
      <div class="main-container">
        <CreatorSidebar />
        <div class="right-wrap">
          <div class="main-content">
            <div class="tab-nav">
              <div class="leftitem">
                <el-tabs
                  @tab-click="activeTabClick"
                  :model-value="activeTab"
                >
                  <el-tab-pane
                    label="内容"
                    name="all"
                    style="font-size: 18px">
                  </el-tab-pane>
                  <el-tab-pane
                    label="草稿箱"
                    name="drafts"></el-tab-pane>
                </el-tabs>
              </div>
              <div class="rightitem">
                <el-input
                  v-model="QueryTitle"
                  placeholder="请输入标题关键字"
                  class="search-input">
                  <template #suffix>
                    <span
                      class="rightitem-inputsearch"
                      @click="querysearch">
                      <el-icon><Search /></el-icon>
                    </span>
                  </template>
                </el-input>
              </div>
            </div>
            <div class="content-tabs">
              <div
                class="tab-pane"
                v-if="activeTab === 'all'">
                <div>
                  <div class="article-list">
                    <div
                      class="article-item"
                      v-for="infoitem in articleinfo"
                      :key="infoitem.article_id">
                      <div class="article-content" >
                        <div
                          class="audit-fail"
                          v-if="infoitem.audit_status == 1">
                          未通过
                        </div>
                        <div
                          class="audit-ing"
                          v-if="infoitem.audit_status == 2">
                          待审核
                        </div>
                        <a :href="`/post/${infoitem.article_id}`" target="_blank"><h3>{{ infoitem.title }}</h3></a>
                        <div class="article-meta">
                          <span>{{ infoitem.created_at }}</span>
                        </div>
                      </div>
                      <div class="article-actions">
                        <el-dropdown>
                          <el-button text>
                            <el-icon><MoreFilled /></el-icon>
                          </el-button>
                          <template #dropdown>
                            <el-dropdown-menu>
                              <el-dropdown-item
                                ><a
                                  :href="`/editor/drafts/${infoitem.article_id}`"
                                  target="_blank"
                                  >编辑</a
                                ></el-dropdown-item
                              >
                              <el-dropdown-item
                                @click="
                                  handleArticleInfoDelete(infoitem.article_id)
                                "
                                >删除</el-dropdown-item
                              >
                            </el-dropdown-menu>
                          </template>
                        </el-dropdown>
                      </div>
                    </div>
                    <div class="article-creator pagination">
                      <el-pagination
                        background
                        :hide-on-single-page="true"
                        layout="prev, pager, next"
                        v-model:current-page="currentPage"
                        v-model:page-size="pageSize"
                        :total="total"
                        @current-change="handleCurrentChange" />
                    </div>
                    <div class="infor-list" v-if="total ==0">
                      <div class="content-flag">
                        <div class="common-empty">
                          <img src="@/assets/img/emoji.png" />
                        </div>
                        <div class="emoji-empty">
                          连emoji都选择微笑的空白区
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane"
                v-if="activeTab === 'drafts'">
                <div class="article-list">
                  <div
                    class="article-item"
                    v-for="draftsitem in articledrafts"
                    :key="draftsitem.drafts_id">
                    <div class="article-content">
                      <h3>{{ draftsitem.title }}</h3>
                      <div class="article-meta">
                        <span>{{ draftsitem.created_at }}</span>
                      </div>
                    </div>
                    <div class="article-actions">
                      <el-dropdown>
                        <el-button text>
                          <el-icon><MoreFilled /></el-icon>
                        </el-button>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item
                              ><a
                                :href="`/editor/drafts/${draftsitem.drafts_id}`"
                                target="_blank"
                                >编辑</a
                              ></el-dropdown-item
                            >
                            <el-dropdown-item
                              @click="handleDraftsDelete(draftsitem.drafts_id)"
                              >删除</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </div>
                  </div>
                  <div class="article-creator pagination">
                    <el-pagination
                      background
                      :hide-on-single-page="true"
                      layout="prev, pager, next"
                      v-model:current-page="currentPage"
                      v-model:page-size="pageSize"
                      :total="total"
                      @current-change="handleDraftsChange" />
                  </div>
                  <div class="infor-list" v-if="total ==0">
                      <div class="content-flag">
                        <div class="common-empty">
                          <img src="@/assets/img/emoji.png" />
                        </div>
                        <div class="emoji-empty">
                          连emoji都选择微笑的空白区
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { Search } from "@element-plus/icons-vue";
import CreatorSidebar from "@/components/CreatorSidebar.vue";
import CreatorHeader from "@/components/CreatorHeader.vue";
import axiosInstance from "@/utils/axiosInstance";
import { WebSite_Name } from "@/interface/globalindex";

import { useHead } from '@vueuse/head'

const SSRData = ref({
  title: '内容管理 - 创作者中心 - '+WebSite_Name,
  description: '默认代码,defaultcode.cn 是宁波的开发者技术社区，为开发者提供纯粹、高质的技术交流平台，让有意思的人聚在一起。',
  keywords: '默认代码,默认代码社区,宁波技术社区,宁波开发者技术交流社区,程序员中文技术社区'
})

// 使用组合式 API 设置 head
useHead({
  title: SSRData.value.title,
  meta: [
    { name: 'description', content: SSRData.value.description },
    { name: 'keywords', content: SSRData.value.keywords }
  ]
})

// 定义当前选中的标签，初始值为 'all'
const activeTab = ref<string>("all");
const QueryTitle = ref("");

//草稿箱
interface ArticleDraft {
  drafts_id: string;
  title: string;
  created_at: string;
}
const articledrafts = ref<ArticleDraft[]>([]);

//正式发布
interface ArticleInfo {
  article_id: string;
  title: string;
  created_at: string;
  audit_status: number;
}
const articleinfo = ref<ArticleInfo[]>([]);

const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);

// 获取文章信息列表
const fetchArticleInfoData = async () => {
  try {
    const response = await axiosInstance.get(
      "/api/ArticleInfo/ArticleInfoList",
      {
        params: {
          page: currentPage.value,
          querytitle: QueryTitle.value,
        },
      }
    );
    var result = response.data;
    if (result.success) {
      articleinfo.value = result.data.data;
      total.value = result.data.dataCount;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};
// 当前页变化处理
const handleCurrentChange = (newPage: number) => {
  currentPage.value = newPage;
  fetchArticleInfoData();
};

// 获取草稿箱
const fetchDraftsData = async () => {
  try {
    const response = await axiosInstance.get(
      "/api/ArticleDrafts/ArticleDraftsList",
      {
        params: {
          page: currentPage.value,
          querytitle: QueryTitle.value,
        },
      }
    );
    var result = response.data;
    if (result.success) {
      articledrafts.value = result.data.data;
      total.value = result.data.dataCount;
    }
  } catch (error) {
    console.error("fail:", error);
  }
};
// 当前页变化处理
const handleDraftsChange = (newPage: number) => {
  currentPage.value = newPage;
  fetchDraftsData();
};

onMounted(() => {
  fetchArticleInfoData();
});
//关键字搜索
const querysearch = () => {
  fetchArticleInfoData();
};
//
const activeTabClick = (tab: any) => {

  const tabName = tab.paneName;
  activeTab.value = tabName; // 手动更新激活标签
  currentPage.value = 1;
  total.value = 0;
  if (tabName === "all") {
    fetchArticleInfoData();
  } else if (tabName === "drafts") {
    fetchDraftsData();
  }
};

//删除草稿箱
const handleDraftsDelete = async (draftsid: string) => {
  try {
    await ElMessageBox.confirm("删除内容后不可恢复，确定删除吗？", "删除内容", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning",
    });

    const response = await axiosInstance.get(
      "/api/ArticleDrafts/ArticleDraftsDelete",
      { params: { drafts_id: draftsid } }
    );
    var result = response.data;
    if (result.success) {
      ElMessage.success("删除成功");
      fetchDraftsData();
    } else {
      ElMessage.error("删除失败");
    }
  } catch (error) {
    console.log("取消删除");
  }
};

//删除文章信息
const handleArticleInfoDelete = async (articleid: string) => {
  try {
    await ElMessageBox.confirm("删除内容后不可恢复，确定删除吗？", "删除内容", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning",
    });

    const response = await axiosInstance.get(
      "/api/ArticleInfo/ArticleInfoDelete",
      { params: { article_id: articleid } }
    );
    var result = response.data;
    if (result.success) {
      ElMessage.success("删除成功");
      fetchArticleInfoData();
    } else {
      ElMessage.error("删除失败");
    }
  } catch (error) {
    console.log("取消删除");
  }
};

// 编辑处理
// const handleEdit = (articleId: string) => {
//   router.push({
//     name: 'EditorDrafts',  // 确保路由配置了name和参数接收
//     params: { article_id: articleId }
//   })
// }
</script>

<style scoped>
.creator-center {
  width: 100%;
  height: 100%;
}
.header {
  padding: 0 20px;
  background: #fff;
  transform: translateZ(0);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  transition: transform 0.2s;
  z-index: 250;
}
.main-container {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  margin-top: 22px;
}

.right-wrap {
  width: 980px;
  margin-left: 220px;
  margin-top: 59px;
}

.main-content {
  min-height: calc(100vh - 108px);
  margin-bottom: 24px;
  padding: 0 20px;
  background: #fff;
}

.tab-nav {
  position: relative;
  margin-bottom: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 1px solid #dcdfe6;
}
.leftitem {
  position: relative;
  z-index: 1;
  float: left;
  white-space: nowrap;
  width: 200px;
}
.el-tabs {
  --el-tabs-header-height: 56px !important;
  line-height: 56px !important;
  vertical-align: top !important;
  margin-bottom: 0px 0px 0px 0px !important;
}

.leftitem ::v-deep .el-tabs__header {
  margin-bottom: 0px;
}
.leftitem ::v-deep .el-tabs__item {
  font-size: 16px;
}
.leftitem ::v-deep .el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #cc5656;
}
.leftitem ::v-deep .el-tabs__active-bar {
  background-color: #cc5656;
}
.rightitem {
  display: flex;
  align-items: center;
}
.search-input {
  width: 240px;
}

/*文章搜索*/

.article-filter {
  margin-bottom: 16px;
}
.article-filter .filter-item:first-child {
  padding-left: 0;
}
.article-filter .filter-item {
  border-right: 1px solid #e5e6eb;
  display: inline-block;
  padding: 0 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #86909c;
}
.article-filter .active-type {
  color: #1d7dfa;
}
.article-filter .filter-item .total {
  margin: 0 8px;
}
.article-filter .filter-item:hover {
  color: #1d7dfa;
  cursor: pointer;
}
.article-filter .filter-item:last-child {
  border-right: none;
}
.article-filter .filter-item .total {
  margin: 0 8px;
}

.article-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}
.article-content {
  flex: 1;
}

h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #1a1a1a;
  cursor: pointer;
}
h3:hover {
  color: #1e80ff;
}
.article-meta {
  color: #8a919f;
  font-size: 13px;
}
.article-meta span {
  margin-right: 16px;
}
article-meta span:last-child {
  margin-right: 0;
}
.article-actions {
  margin-left: 16px;
}
.article-creator {
  display: flex;
  justify-content: center;
  padding: 24px 0 32px;
  width: 100%;
}
.pagination {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.rightitem-inputsearch {
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 32px;
  right: 0;
  cursor: pointer;
}
.audit-fail {
  color: #f03535;
  background: #ffece8;
  width: 39px;
  display: block;
  font-size: 12px;
}
.audit-ing {
  color: #ff7d00;
  background: #fff7e8;
  width: 39px;
  display: block;
  font-size: 12px;
}
.content-flag {
  font-size: 16px;
  font-weight: 400;
  color: #8a919f;
  margin-top:50px;
}
.emoji-empty {
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  margin-top: 8px;
  color: #8a919f;
}
.common-empty {
	display: flex;
	justify-content: center;
	margin-bottom: 32px;
}
</style>
